export const Datachain = {
	CachedLang: 'hdh_lang',
};
